import { useSelector } from 'react-redux';
import { Container, ContentWrapper } from './styles';
import UnifiedOccurrencesTable from './UnifiedOccurrencesTable/UnifiedOccurrencesTable';

const Dashboard = () => {
  const collapsed = useSelector((state) => state.sidebar);

  return (
    <Container collapsed={collapsed}>
      <ContentWrapper>
        <UnifiedOccurrencesTable />
      </ContentWrapper>
    </Container>
  );
};

export default Dashboard;
